/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkOpErrorDTO } from './BulkOpErrorDTO';
import {
    BulkOpErrorDTOFromJSON,
    BulkOpErrorDTOFromJSONTyped,
    BulkOpErrorDTOToJSON,
} from './BulkOpErrorDTO';

/**
 * 
 * @export
 * @interface BulkOpResultDTO
 */
export interface BulkOpResultDTO {
    /**
     * Errors.
     * @type {Array<BulkOpErrorDTO>}
     * @memberof BulkOpResultDTO
     */
    errors: Array<BulkOpErrorDTO>;
    /**
     * The entries updated successfully.
     * @type {Array<string>}
     * @memberof BulkOpResultDTO
     */
    updatedExperimentIdentifiers: Array<string>;
}

/**
 * Check if a given object implements the BulkOpResultDTO interface.
 */
export function instanceOfBulkOpResultDTO(value: object): value is BulkOpResultDTO {
    if (!('errors' in value) || value['errors'] === undefined) return false;
    if (!('updatedExperimentIdentifiers' in value) || value['updatedExperimentIdentifiers'] === undefined) return false;
    return true;
}

export function BulkOpResultDTOFromJSON(json: any): BulkOpResultDTO {
    return BulkOpResultDTOFromJSONTyped(json, false);
}

export function BulkOpResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkOpResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'errors': ((json['errors'] as Array<any>).map(BulkOpErrorDTOFromJSON)),
        'updatedExperimentIdentifiers': json['updatedExperimentIdentifiers'],
    };
}

export function BulkOpResultDTOToJSON(value?: BulkOpResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'errors': ((value['errors'] as Array<any>).map(BulkOpErrorDTOToJSON)),
        'updatedExperimentIdentifiers': value['updatedExperimentIdentifiers'],
    };
}

